import { render, staticRenderFns } from "./wrapped-dialog.vue?vue&type=template&id=5dd2e408&scoped=true&"
import script from "./wrapped-dialog.vue?vue&type=script&lang=js&"
export * from "./wrapped-dialog.vue?vue&type=script&lang=js&"
import style0 from "./wrapped-dialog.vue?vue&type=style&index=0&id=5dd2e408&prod&lang=scss&"
import style1 from "./wrapped-dialog.vue?vue&type=style&index=1&id=5dd2e408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd2e408",
  null
  
)

export default component.exports